import { Select } from '@civilgrid/ui/components';
import { useMemo } from 'react';
import { IntelligenceStatus, StatusLabels } from '.';

interface Props {
  value?: string;
  onChange?: (v: string) => void;
  isActive?: boolean;
  color?: string;
  'data-testid'?: string;
}

export default function StatusSelect({
  value,
  onChange,
  isActive,
  color,
  'data-testid': testId = 'intelligence-status-select',
}: Props) {
  const options = useMemo(() => {
    return Object.values(IntelligenceStatus).map((status) => ({
      value: status,
      label: StatusLabels[status] || StatusLabels[IntelligenceStatus.NeedsAttention],
    }));
  }, []);

  let ping: JSX.Element | null = null;

  if (isActive) {
    ping = (
      <div
        className="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
        style={{ backgroundColor: color || 'red' }}
      />
    );
  }

  return (
    <div className="flex w-full items-center justify-start" onClick={(e) => e.stopPropagation()}>
      <div className="pointer-events-none relative flex h-5 w-5 shrink-0 items-center justify-center">
        {ping}
        <div className="relative inline-flex h-3 w-3 rounded-full" style={{ backgroundColor: color }} />
      </div>
      <div className="w-full min-w-0 truncate whitespace-nowrap text-left">
        <Select
          aria-label="Intelligence status"
          options={options}
          value={value}
          onValueChange={(v) => {
            if (v) onChange?.(v);
          }}
          data-testid={testId}
        />
      </div>
    </div>
  );
}
